import React from 'react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'
import { IconLock, IconSparkles } from '@tabler/icons-react'

import { Checkbox } from '@/components/forms/Checkbox'
import { WinIcon } from '@/components/icons/WinIcon'
import { accessors } from '../../playbook.helpers'

export const ChecklistEntryPreview = ({ isEditEntry, entry, accessor }) => {
  if (!entry) {
    return null
  }

  const renderIcon = () => {
    if (accessor === accessors.DYNAMIC_PROMPT && !entry.win) {
      // Stands in for a bullet glyph alongside WinIcon / IconSparkles, so it is decoration.
      return <Checkbox readOnly aria-hidden="true" tabIndex={-1} />
    }

    if (entry.win) {
      return <WinIcon className="win-icon" data-testid="win-icon" />
    }

    if (!isEmpty(entry.ai_checklist_prompt)) {
      return <IconSparkles className="status-magical" />
    }

    if (entry.is_locked) {
      return <IconLock />
    }

    return null
  }

  const icon = renderIcon()
  const isDefault = !icon

  return (
    <div className={classNames('checklist-entry', { muted: !isEditEntry })}>
      {isDefault ? <div className="bullet" /> : icon}
      <span>{entry.name}</span>
    </div>
  )
}
